export default __webpack_public_path__ + "static/media/CNo.40-4.3e41e771.jpg";